import { render, staticRenderFns } from "./bcgsbxbl.vue?vue&type=template&id=361e0cc7&scoped=true&"
import script from "./bcgsbxbl.vue?vue&type=script&lang=js&"
export * from "./bcgsbxbl.vue?vue&type=script&lang=js&"
import style0 from "./bcgsbxbl.vue?vue&type=style&index=0&id=361e0cc7&lang=less&scoped=true&"
import style1 from "./bcgsbxbl.vue?vue&type=style&index=1&id=361e0cc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e0cc7",
  null
  
)

export default component.exports